export const AccessPriviledgeContent = {
    "dari": {
        "Sub Distributor Management": "مدیریت توزیع کننده فرعی",
        "Listing Sub Distributor": "تهیه لیست توزیع کننده فرعی",
        "Distributor Management": "مدیریت توزیع کننده",
        "Listing Distributor": "تهیه لیست توزیع کننده",
        "Add Distributor": "افزودن توزیع کننده",
        "Distributor Transactions": "مبادلات توزیع کننده",
        "Edit Distributor": "تصحیح توزیع کننده",
        "Activate / Deactivate Distributor": "فعال/غیر فعال ساختن توزیع کننده",
        "Flagging Distributor Transactions": "علامت گذاری مبادلات توزیع کننده",
        "View Specific Distributor Details": "نمایش اطلاعات خاص در مورد توزیع کننده",
        "Agent Management": "مدیریت نمایندگان",
        "Listing Agent": "تهیه لیست نمایندگان",
        "Add Agent": "افزودن نماینده",
        "Agent Transactions": "مبادلات نماینده",
        "Edit Agent": "تصحیح نماینده",
        "Activate / Deactivate Agent": "فعال/غیر فعال ساختن نماینده",
        "Flagging Agent Transactions": "علامت گذاری مبادلات نماینده",
        "View Specific Agent Details": "نمایش اطلاعات خاص در مورد نماینده",
        "Retailer Management": "مدیریت پرچون فروشان",
        "Listing Retailers": "تهیه لیست پرچون فروشان",
        "Add Retailer": "افزودن پرچون فروش",
        "Retailer Transactions": "مبادلات پرچون فروشان",
        "Edit Retailer": "تصحیح پرچون فروش",
        "Activate / Deactivate Retailer": "فعال/غیر فعال ساختن پرچون فروش",
        "Flagging Retailer Transactions": "علامت گذاری مبادلات پرچون فروشان",
        "View Specific Retailer": "نمایش اطلاعات خاص در مورد پرچون فروشان",
        "Customer Management": "مدیریت مشتریان",
        "Listing Customer": "تهیه لیست مشتری",
        "Add Customer": "افزودن مشتری",
        "Customer Transactions": "مبادلات مشتری",
        "Edit Customer": "تصحیح مشتری",
        "Activate / Deactivate Customer": "فعال/غیر فعال ساختن مشتری",
        "View Specific Customer Details": "نمایش معلومات خاص در مورد مشتری",
        "Reversal Request": "درخواست اعاده",
        "Listing Reversal Request": "تهیه لیست درخواست‌های اعاده",
        "View Specific Reversal Request Details": "نمایش اطلاعات خاص در مورد درخواست‌های اعاده",
        "Approve / Reject Reversal Request": "تایید/رد درخواست",
        "Services": "خدمات",
        "Do Mobile Recharge": "پرداخت کریدت موبایل",
        "Bundle / Package Activation": "فعال ساختن بسته/پکیج",
        "Breshna Service Utilization": "استفاده از خدمات برشنا",
        "Company Management": "مدیریت شرکت",
        "Listing Company": "تهیه لیست شرکت",
        "View Specific Company Details": "نمایش اطلاعات خاص در مورد شرکت",
        "Edit Company": "تصحیح شرکت",
        "MNO Management": "مدیریت اپراتورهای شبکه مخابراتی (موبایل)",
        "Listing MNO": "تهیه لیست اپراتورهای شبکه موبایل",
        "Add MNO": "افزودن اپراتورهای شبکه موبایل",
        "Edit MNO": "تصحیح اپراتورهای شبکه موبایل",
        "Add Purchase Amount": "افزودن مبلغ خرید",
        "Add Service Fee": "افزودن هزینه خدمات",
        "View Specific MNO Details": "نمایش اطلاعات خاص در مورد اپراتورهای شبکه موبایل",
        "Support Ticket": "تکیت پشتیبانی",
        "Listing Support Ticket": "تهیه لیست تکیت پشتیبانی",
        "View Specific Support Ticket Details": "نمایش اطلاعات خاص در مورد تکیت پشتیبانی",
        "Take Action on Support Ticket": "اقدام عملی در زمینه تکیت پشتیبانی",
        "Onboarding Request": "درخواست شروع به کار",
        "Listing All Onboarding Request": "تهیه لیست درخواست‌های شروع به کار",
        "View Specific Onboarding Request Details": "نمایش خاص اطلاعات درخواست شروع به کار",
        "Edit the Onboarding Request": "تصحیح درخواست شروع به کار",
        "Approve / Reject the Onboarding Request": "تایید/رد درخواست شروع به کار",
        "Modification Request": "درخواست اِعمال تغییرات",
        "Listing All Modification Request": "تهیه لیست تمام درخواست‌های اِعمال تغییرات",
        "View Specific Modification Request Details": "نمایش اطلاعات خاص در مورد درخواست‌های اِعمال تغییرات",
        "Edit the Modification Request": "تصحیح درخواست اعمال تغییرات",
        "Approve / Reject the Modification Request": "تایید/رد درخواست اِعمال تغییرات",
        "Dashboard": "داشبورد",
        "Total Number of Users on the Platform": "تعداد مجموعی کاربران در پلتفورم",
        "Total Number of Receivables": "تعداد مجموعی اقلام قابل دریافت",
        "Total Number of Payables": "تعداد مجموعی اقلام قابل پرداخت",
        "Recharge Report": "گزارش اضافه کردن کریدیت (ریچارج)",
        "MNO Wise Package Sales Trend": "روند فروش پکیچ بر اساس اپراتور شبکه موبایل",
        "Merchant Wise MNO Package Activation Sales": "فروش پکیج اپراتورهای شبکه موبایل بر اساس فروشنده",
        "Geographical MNO Recharge Sales": "فروش کریدیت اپراتورهای شبکه موبایل بر اساس محدوده جغرافیایی",
        "Geographical MNO Package Activation Sales": "فروش پکیج اپراتورهای شبکه موبایل بر اساس محدوده جغرافیایی",
        "Geographical ETop Up Stock Sales": "فروش سهام ETop Up براساس محدوده جغرافیایی",
        "Merchant Wise MNO Recharge Sales": "فروش کریدیت اپراتورهای شبکه موبایل بر اساس فروشنده",
        "Customer MNO Recharge Sales": "فروش کریدیت اپراتور شبکه موبایل بر اساس مشتری",
        "MNO Available Balance": "بیلانس موجودی اپراتور شبکه موبایل",
        "MNO Wise Recharge Sales Trend": "روند فروش کریدیت بر اساس اپراتور شبکه موبایل",
        "MNO Target Vs Achievement": "هدف اپراتور شبکه موبایل در مقایسه با دستاورد",
        "ETop Up Stock Sales Trend": "روند فروش سهام ETop Up",
        "Merchant Wise ETop Up Stock Sales": "فروش سهام ETop Up براساس فروشنده",
        "CVM Dashboard": "داشبورد ارتقای ارزش مشتری (CVM)",
        "Active / Inactive / Dormant Users Status": "حالت‌های فعال سازی/غیر فعال/توقف یافته کاربران",
        "Target vs Achievement": "هدف در مقایسه با دستاورد",
        "Top 3 Merchant Wise ETop Up Stock Transfer Ranking": "رتبه بندی انتقال سهام ETop Up بر اساس 3 فروشنده برتر",
        "Count of Users": "تعداد کاربران",
        "System Transactional Performance Ratio": "نسبت عملکرد مبادلات سیستم",
        "Reports": "گزارش‌ها",
        "ETop Up Recharge Report": "گزارش تغذیه مجدد (ریچارج) Etop Up",
        "Bundle Activation Report": "گزارش فعال سازی بسته",
        "Unsuccessful Transaction Report": "گزارش مبادلات ناموفق",
        "MNO's Service Fee Earned Report": "گزارش مصارف دریافت شده خدمات  توسط اپراتورهای شبکه موبایل",
        "MNO Wise Sales Trend Report": "گزارش زوند فروشات بر اساس اپراتورهای شبکه موبایل",
        "Stock Transfer Report": "گزارش سفارش خرید سهام Etop Up",
        "Wallet Transfer Report": "گزارش انتقال والت (بکسک پول)",
        "MNO Wise ETop Up Available Balance Report": "گزارش موجودی بیلانس ETop Up بر اساس اپراتور شبکه موبایل",
        "MNO Wise Bundle Balance Activation Report": "گزارش بیلانس فعال سازی بسته بر اساس اپراتور شبکه موبایل",
        "MNO Wise ETop Up Purchase Report": "گزارش خرید ETop Up بر اساس اپراتور شبکه موبایل",
        "MNO Wise Bundle Balance Purchase Report": "گزارش خرید بیلانس بسته بر اساس اپراتور شبکه موبایل",
        "Merchant / Customer eTop Up Wallet Balance Report": "گزارش بیلانس والت ETop Up بر اساس فروشنده/مشتری",
        "ZoodPay Profitability Report": "گزارش سودآوری زودپی",
        "Recharge Reversal Report": "گزارش اعاده بازپرداخت",
        "ETop Up Stock / Digital Wallet Report of Admin / Super Admin": "گزارش موجودی ETop Up / والت دیجیتال مدیر/مدیر ارشد",
        "CVM Report": "گزارش توزیع کمیشن CVM",
        "On Target Achievement of MNO Report": "گزارش دستیابی به هدف اپراتور شبکه موبایل",
        "Geographical Sales Report": "گزارش فروشات بر اساس ساحات جغرافیایی",
        "Stock Account Statement": "صورتحساب حساب موجودی (سهام)",
        "Money Accounts Statement": "صورتحساب حساب‌های پولی",
        "Upfront Purchased Report": "گزارش پیش خریدها",
        "Upfront Sales Report": "گزارش پیش فروش‌ها",
        "Bulk Amount Transfer": "انتقال مبلغ کلان",
        "Capability to do Bulk Recharge": "ظرفیت انجام تغذیه کلان",
        "Wallet / Fund Transfer": "انتقال بودجه/والت",
        "Capability to do Bulk Bundle Activation": "ظرفیت فعال سازی بسته کلان",
        "Career Section Management": "مدیریت بخش وظیفوی",
        "Add Data Related to Career": "افزودن اطلاعات مربوط به وظیفه",
        "Remove Data Related to Career": "حذف اطلاعات مربوط به وظیفه",
        "View all Job Application": "نمایش تمام درخواستی‌های کاری",
        "Blog Management": "مدیریت بلاگ",
        "Add Blog": "افزودن بلاگ",
        "Remove Blog": "حذف بلاگ",
        "View the Blog": "نمایش بلاگ مذکور",
        "Digital wallet": "والت دیجیتل",
        "View Specific Sub Distributor Details": "نمایش اطلاعات خاص در مورد توزیع کننده فرعی",
        "Edit Sub Distributor": "تصحیح توزیع کننده فرعی",
        "Activate / Deactivate Sub Distributor": "فعال/غیر فعال ساختن توزیع کننده فرعی",
    },
    "pashto": {
        "Sub Distributor Management": "د فرعي توزېع کوونکي مدیریت",
        "Listing Sub Distributor": "د فرعي توزېع کوونکي لېست کول",
        "Distributor Management": "د توزېع کوونکي مدیریت",
        "Listing Distributor": "د توزېع کوونکي لېست کول",
        "Add Distributor": "د توزېع کوونکي اضافه کول",
        "Distributor Transactions": "د توزېع کوونکي مبادلات",
        "Edit Distributor": "د توزېع کوونکي سمول",
        "Activate / Deactivate Distributor": "د توزېع کوونکي فعالول/غیر فعالول",
        "Flagging Distributor Transactions": "د توزېع کوونکي مبادلاتو نښه کول",
        "View Specific Distributor Details": "د توزېع کوونکي په اړه د ځانګړو جزئیاتو ښوودنه",
        "Agent Management": "د استازي مدیریت",
        "Listing Agent": "د استازي لېست کول",
        "Add Agent": "د استازي اضافه کول",
        "Agent Transactions": "د استازي مبادلات",
        "Edit Agent": "د استازي سمول",
        "Activate / Deactivate Agent": "د استازي فعالول/غیر فعالول",
        "Flagging Agent Transactions": "د استازي مبادلاتو نښه کول",
        "View Specific Agent Details": "د استازي په اړه د ځانګړو جزئیاتو ښوودنه",
        "Retailer Management": "د پرچون پلورونکو مدیریت",
        "Listing Retailers": "د پرچون پلورونکو لېست کول",
        "Add Retailer": "د پرچون پلورونکو اضافه کول",
        "Retailer Transactions": "د پرچون پلورونکو مبادلات",
        "Edit Retailer": "د پرچون پلورونکو سمول",
        "Activate / Deactivate Retailer": "د پرچون پلورونکو فعالول/غیر فعالول",
        "Flagging Retailer Transactions": "د پرچون پلورونکو مبادلاتو نښه کول",
        "View Specific Retailer": "د پرچون پلورونکو په اړه د ځانګړو جزئیاتو ښوودنه",
        "Customer Management": "د پېرودونکو مدیریت",
        "Listing Customer": "د پېرودونکو لېست کول",
        "Add Customer": "د پېرودونکو اضافه کول",
        "Customer Transactions": "د پېرودونکي مبادلات",
        "Edit Customer": "د پېرودونکي سمول",
        "Activate / Deactivate Customer": "د پېرودونکو فعالول/غیر فعالول",
        "View Specific Customer Details": "د پېرودونکو په اړه د ځانګړو جزئیاتو ښوودنه",
        "Reversal Request": "د اعادې غوښتنه",
        "Listing Reversal Request": "د اعادې د غوښتنې لېست کول",
        "View Specific Reversal Request Details": "د اعادې د غوښتنو په اړه د ځانګړو جزئیاتو ښوودنه",
        "Approve / Reject Reversal Request": "د غوښتنې تایید/رد",
        "Services": "خدمات",
        "Do Mobile Recharge": "مبایل ته کرېډېټ اچول",
        "Bundle / Package Activation": "د بستې/کڅوړې فعالول",
        "Breshna Service Utilization": "د برېښنا د خدماتو کارول",
        "Company Management": "د شرکت مدیریت",
        "Listing Company": "د شرکت لېست جوړول",
        "View Specific Company Details": "د شرکت په اړه د ځانګړو جزئیاتو ښوودنه",
        "Edit Company": "د شرکت سمول",
        "MNO Management": "د مخابراتی شبکې د آپرېټرانو مدیریت",
        "Listing MNO": "د مخابراتی شبکې د آپرېټرانو لېست کول",
        "Add MNO": "د مخابراتي شبکې د آپرېټرانو اضافه کول",
        "Edit MNO": "د مخابراتي شبکې د آپرېټرانو سمول",
        "Add Purchase Amount": "د پېرودلو د مبلغ اضافه کول",
        "Add Service Fee": "د خدماتو د فیس اضافه کول",
        "View Specific MNO Details": "د مخابراتي شبکې د آپرېټرانو په اړه د ځانګړو جزئیاتو ښوودنه",
        "Support Ticket": "حمایتي ټکټ",
        "Listing Support Ticket": "د حمایتي ټکټ لېست کول",
        "View Specific Support Ticket Details": "د حمایتي ټکټ په اړه د ځانګړو جزئیاتو ښوودنه",
        "Take Action on Support Ticket": "د حمایتي ټکټ په اړه عملي اقدام",
        "Onboarding Request": "د کار د پیلولو لپاره غوښتنه",
        "Listing All Onboarding Request": "د کار د پیلولو لپاره د ټولو غوښتنو لېست کول",
        "View Specific Onboarding Request Details": "د کار د پیلولو لپاره د غوښتل شوو جزئیاتو ښوودنه",
        "Edit the Onboarding Request": "د کار د پیلولو لپاره د غوښتنې سمول",
        "Approve / Reject the Onboarding Request": "د کار د پیلولو د غوښتنې تایید/رد",
        "Modification Request": "د بدلون راوستلو غوښتنه",
        "Listing All Modification Request": "د بدلون راوستلو د ټولو غوښتنو لېست کول",
        "View Specific Modification Request Details": "د بدلون راوستلو لپاره د غوښتل شوو ځانګړو جزئیاتو ښوودنه",
        "Edit the Modification Request": "د بدلون راوستلو د غوښتنې سمول",
        "Approve / Reject the Modification Request": "د بدلون راوستلو د غوښتنې تایید/رد",
        "Dashboard": "ډشبورډ",
        "Total Number of Users on the Platform": "په پلټفارم کې د کاروونکو ټولټال شمېر",
        "Total Number of Receivables": "د ترلاسه کېدونکو توکو ټولټال شمېر",
        "Total Number of Payables": "د ورکړې وړ توکو ټولټال شمېر",
        "Recharge Report": "د کرېډېټ ډېرولو راپور",
        "MNO Wise Package Sales Trend": "د مخابراتي شبکې د اپرېټر پر اساس د کڅوړې (پکېچ) د خرڅلاو پروسه",
        "Merchant Wise MNO Package Activation Sales": "د پلورونکي پر اساس  د مخابراتي شبکې د اپرېټرانو د کڅوړې (کرېډېټ) خرڅلاو",
        "Geographical MNO Recharge Sales": "د جغرافیایي محدودې پر اساس د مخابراتي شبکې د اپرېټرانو د کرېډېټ ډېرولو خرڅلاو",
        "Geographical MNO Package Activation Sales": "د جغرافیایي محدودې پر اساس د مخابراتي شبکې د اپرېټرانو د کڅوړې (پکېج)  خرڅلاو",
        "Geographical ETop Up Stock Sales": "د جغرافیايي محدودې پر اساس د ETop Up د ونډو خرڅلاو",
        "Merchant Wise MNO Recharge Sales": "د پلورونکي پر اساس  د مخابراتي شبکې د اپرېټرانو د کرېډېټ خرڅلاو",
        "Customer MNO Recharge Sales": "د پېرودونکي پر اساس د مخابراتی شبکې د اپرېټرانو د کرېډېټ خرڅلاو",
        "MNO Available Balance": "د مخابراتي شبکې د اپرېټرانو د موجودۍ بیلانس",
        "MNO Wise Recharge Sales Trend": "د مخابراتي شبکې د اپرېټر پر اساس د کرېډېټ ډېرولو د خرڅلاو پروسه",
        "MNO Target Vs Achievement": "د مخابراتي شبکې د آپرېټرانو موخه د لاسته راوړنې په مقابل کې",
        "ETop Up Stock Sales Trend": "د ETop Up د ونډو د خرڅلاو پروسه",
        "Merchant Wise ETop Up Stock Sales": "د پلورونکي پر اساس د ETop Up د ونډو  خرڅلاو",
        "CVM Dashboard": "د پېرودونکي د ارزښت لوړولو ډشبورد",
        "Active / Inactive / Dormant Users Status": "د کاروونکو د فعالولو/غیر فعالولو/درولو حالتونه",
        "Target vs Achievement": "موخه د لاسته راوړنې په مقابل کې",
        "Top 3 Merchant Wise ETop Up Stock Transfer Ranking": "د درېیو غوره پلورونکو پر اساس د ETop Up د انتقال د رتبه بندۍ ونډه",
        "Count of Users": "د کاروونکو شمېر",
        "System Transactional Performance Ratio": "د سیستم د مبادلاتو د کړنې نسبت",
        "Reports": "راپورونه",
        "ETop Up Recharge Report": "د Etop Up کرېډېټ ډېرولو راپور",
        "Bundle Activation Report": "د بستې/کڅوړې فعالولو راپور",
        "Unsuccessful Transaction Report": "د نا بریالیو مبادلاتو راپور",
        "MNO's Service Fee Earned Report": "د مخابراتي شبکې د آپرېټرانو لخوا د ترلاسه شوو خدماتو د لګښتونو راپور",
        "MNO Wise Sales Trend Report": "د مخابراتي شبکې د آپرېټر انو پر اساس د خرڅلاو د پروسې راپور",
        "Stock Transfer Report": "د Etop Up د ونډو د پېرلو راپور",
        "Wallet Transfer Report": "د بټوې د انتقال راپور",
        "MNO Wise ETop Up Available Balance Report": "د مخابراتي شبکې د اپرېټر پر اساس د Etop Up د بیلانس د موجودۍ راپور",
        "MNO Wise Bundle Balance Activation Report": "د مخابراتي شبکې د اپرېټرانو پر اساس د بستې د فعالولو د بیلانس راپور",
        "MNO Wise ETop Up Purchase Report": "د مخابراتي شبکې د اپرېټر  پر اساس د Etop Up د پېرلو راپور",
        "MNO Wise Bundle Balance Purchase Report": "د مخابراتي شبکې د آپرېټور پر اساس د بستې د بیلانس د پېرلو راپور",
        "Merchant / Customer eTop Up Wallet Balance Report": "د پلورونکي/پېرودونکي پر اساس د Etop Up د بټوې (والېټ) د بیلانس راپور",
        "ZoodPay Profitability Report": "د زود پې د ګټې کولو راپور",
        "Recharge Reversal Report": "د کرېډټ ډېرولو د اعادې راپور",
        "ETop Up Stock / Digital Wallet Report of Admin / Super Admin": "د مدیر/سر مدیر د Etop Up د موجودۍ/دیجیتلي بټوې راپور",
        "CVM Report": "د CVM راپور",
        "On Target Achievement of MNO Report": "د مخابراتي شبکې د اپرېټور د ترلاسه کېدونکې موخې راپور",
        "Geographical Sales Report": "د جغرافیايي ساحو پر اسس د پلور راپور",
        "Stock Account Statement": "د موجودي صورت حساب",
        "Money Accounts Statement": "د پیسو د حسابونو صورت حساب",
        "Upfront Purchased Report": "له مخکې د پېرل شویو راپور",
        "Upfront Sales Report": "له مخکې د پلورل شویو راپور",
        "Bulk Amount Transfer": "د لوی مقدار مبلغ انتقال",
        "Capability to do Bulk Recharge": "د لوی مقدار بیا اضافه کولو (ریچارج) ظرفیت",
        "Wallet / Fund Transfer": "د بټوې/بودیجې انتقال",
        "Capability to do Bulk Bundle Activation": "د لوی مقدار بستې د فعالولو ظرفیت",
        "Career Section Management": "د کاري/مسلکي برخې مدیریت",
        "Add Data Related to Career": "په کاري برخه/مسلک پورې د اړوندې ډېټا اضافه کول",
        "Remove Data Related to Career": "په کاري برخه/مسلک پورې د اړوندې ډېټا لرې کول",
        "View all Job Application": "د ټولو کاري غوښتنو ښوودنه",
        "Blog Management": "د بلاګ مدیریت",
        "Add Blog": "د بلاګ اضافه کول",
        "Remove Blog": "د بلاګ لرې کول",
        "View the Blog": "د بلاګ ښوودنه",
        "Digital wallet": "دیجتلي بټوه (والېټ)",
        "View Specific Sub Distributor Details": "د فرعي توزېع کوونکي په اړه د ځانګړو جزئیاتو ښوودنه",
        "Edit Sub Distributor": "د فرعي توزېع کوونکي سمول",
        "Activate / Deactivate Sub Distributor": "د فرعي توزېع کوونکي فعالول/غیر فعالول",
    },
    "uzbeki": {
        "Sub Distributor Management": "فرعی توزیع قیلوچی باشقریش",
        "Listing Sub Distributor": "فرعی توزیع قیلوچی رویخطینی تیارلش",
        "Distributor Management": "توزیع قیلوچی باشقرووی",
        "Listing Distributor": "توزیع قیلوچی رویخطینی تیارلش",
        "Add Distributor": "توزیع قیلوچینی قوشیش",
        "Distributor Transactions": "توزیع قیلوچی المشووی",
        "Edit Distributor": "توزیع قیلوچی نی توغریلش",
        "Activate / Deactivate Distributor": "توزیع قیلوچی نی فعال/ غیر فعال ایتیش",
        "Flagging Distributor Transactions": "توزیع قیلوچی المشووی نی علامتلنگ",
        "View Specific Distributor Details": "توزیع قیلوچی حقیده انیق معلومات",
        "Agent Management": "نماینده‌لر باشقرووی",
        "Listing Agent": "نماینده‌لر رویخطینی تیارلش",
        "Add Agent": "نماینده‌نی قوشیش",
        "Agent Transactions": "نماینده المشووی",
        "Edit Agent": "نماینده‌نی توغریلیش",
        "Activate / Deactivate Agent": "نماینده‌نی فعال/ غیر فعال ایتیش",
        "Flagging Agent Transactions": "نماینده المشووی نی علامتلنگ",
        "View Specific Agent Details": "نماینده‌ حقیده انیق معلومات",
        "Retailer Management": "چکنه (پرچون) ساتوچیلر باشقرووی",
        "Listing Retailers": "چکنه (پرچون) ساتوچیلر رویخطینی تیارلش",
        "Add Retailer": "چکنه (پرچون) ساتوچینی قوشیش",
        "Retailer Transactions": "چکینه (پرچون) ساتوچیلر المشیووی",
        "Edit Retailer": "چکنه‌ (پرچون) ساتوچینی توغریلش",
        "Activate / Deactivate Retailer": "چکنه (پرچون) ساتوچینی فعال/ غیر فعال ایتیش",
        "Flagging Retailer Transactions": "چکینه (پرچون) ساتوچیلر المشیووی نی علامتلنگ",
        "View Specific Retailer": "چکنه (پرچون) ساتوچی حقیده انیق معلوماتنی کورسه‌تیش",
        "Customer Management": "مشتریلر باشقرووی",
        "Listing Customer": "مشتریلر رویخطینی تیارلش",
        "Add Customer": "مشترینی قوشیش",
        "Customer Transactions": "مشتری المشیووی",
        "Edit Customer": "مشترینی توغریلش",
        "Activate / Deactivate Customer": "مشترینی فعال/ غیر فعال ایتیش",
        "View Specific Customer Details": "مشتری حقیده انیق معلوماتنی کورسه‌تیش",
        "Reversal Request": "درخواست نی تیکلش",
        "Listing Reversal Request": "درخواست نی تیکلش رویخطینی تیارلش",
        "View Specific Reversal Request Details": "درخواست نی تیکلش باره سیده انیق معلومات کورستیش",
        "Approve / Reject Reversal Request": "ایستکنی تصدیق/رد ایتیش",
        "Services": "خذمتلر",
        "Do Mobile Recharge": "مبایلگه کریدت تشلش",
        "Bundle / Package Activation": "بسته/پکیج نی فعال ایتیش",
        "Breshna Service Utilization": "برشنا خذمتلریدن فایده‌له‌نیش",
        "Company Management": "شرکت باشقرووی",
        "Listing Company": "شرکت رویخطینی تیارلش",
        "View Specific Company Details": "شرکت حقیده انیق معلومات نی کورستیش",
        "Edit Company": "شرکت نی توغریلش",
        "MNO Management": "مخابراتی ترماق (مبایل) اپراتورلر باشقرووی",
        "Listing MNO": "مبایل ترماغی اپراتورلر رویخطینی تیارلش",
        "Add MNO": "مبایل ترماقلری اپراتورلری رویخطینی تیارلش",
        "Edit MNO": "مبایل ترماغی اپراتورلرینی توغریلش",
        "Add Purchase Amount": "ساتیب آلیش مبلغ نی قوشیش",
        "Add Service Fee": "خذمتلر خرجتینی قوشیش",
        "View Specific MNO Details": "مبایل ترماقلری اپراتورلری حقیده انیق معلومات کورسه‌تیش",
        "Support Ticket": "قوللش تکیت",
        "Listing Support Ticket": "قوللش  تکیت رویخطینی تیارلش",
        "View Specific Support Ticket Details": "قوللش تکیت باره‌سیده انیق معلومات کورسه‌تیش",
        "Take Action on Support Ticket": "قوللش تکیت باره‌سیده عملی چاره",
        "Onboarding Request": "ایش باشلش ایستگی",
        "Listing All Onboarding Request": "ایشگه باشلش ایستکلری رویخطینی تیارلش",
        "View Specific Onboarding Request Details": "ایشگه باشلش ایستگی باره‌سیده انیق معلومات",
        "Edit the Onboarding Request": "ایشگه باشلش ایستگینی توغریلش",
        "Approve / Reject the Onboarding Request": "ایشگه باشلش ایستگی تصدیق/رد",
        "Modification Request": "اوزگرتیریشلرنی قوللشنی سوره‌ش",
        "Listing All Modification Request": "اوزگرتیریشنی قوولش ایستکلری برچه رویخطینی تیارلش",
        "View Specific Modification Request Details": "اوزگرتیریشنی قوولش ایستکلری حقیده انیق معلومات کورسه‌تیش",
        "Edit the Modification Request": "اوزگرتیریشنی قوولش ایستگینی توغیریلش",
        "Approve / Reject the Modification Request": "اوزگرتیریشنی قوولش ایستگینی تصدیق/رد",
        "Dashboard": "داشبورد",
        "Total Number of Users on the Platform": "پلتفورده‌گی فایده‌لنوچیلرنینگ عمومی سانی",
        "Total Number of Receivables": "قبول قیلینیشی ممکن بولگن نرسه‌لر نینگ عمومي سانی",
        "Total Number of Payables": "تولنه دیگن نرسه‌لرنینگ عمومی سانی",
        "Recharge Report": "قیته آزیقه‌لنتیریش گزارشی (ریچارج)",
        "MNO Wise Package Sales Trend": "مبایل ترماغی اپراتور اساسیده پکیج نی ساتیش جریانی",
        "Merchant Wise MNO Package Activation Sales": "ساتووچی اساسیده مبایل علاقه‌ اوپرا‌تورلری نینگ پکیج ساتیش",
        "Geographical MNO Recharge Sales": "مبایل علاقه‌ اوپرا‌تورلری نینگ جغرافیایی حدودگه قره‌ب کریدیت ساتیش",
        "Geographical MNO Package Activation Sales": "جغرافیا حدود بوییچه‌ مبایل علاقه‌ اوپرا‌تورلری نینگ پکیج ساتیش",
        "Geographical ETop Up Stock Sales": "ETop Up سهاملرنی جغرافیا حدودگه قره‌ب ساتیش",
        "Merchant Wise MNO Recharge Sales": "مبایل علاقه‌ اوپرا‌تورلری نینگ ساتووچیگه اساسلنگن کریدیت ساتیش",
        "Customer MNO Recharge Sales": "مشتری اساسیده مبایل علاقه‌ اوپیرا‌توری کریدیتینی ساتیش",
        "MNO Available Balance": "مبایل ترماغی اپراتور موجود بلانسی",
        "MNO Wise Recharge Sales Trend": "مبایل ترماغی اپراتور اساسیده کریدیت ساتیش جریانی",
        "MNO Target Vs Achievement": "مبایل ترماغی اپراتور مقصدی نینگ یوتوغی",
        "ETop Up Stock Sales Trend": "سهام‌نی ساتیش جریانی ETop Up",
        "Merchant Wise ETop Up Stock Sales": "ساتوچی اساسیده ETop Up سهامنی ساتیش",
        "CVM Dashboard": "مشتری قیمتینی آشیریش داشبوردی (CVM)",
        "Active / Inactive / Dormant Users Status": "فایده‌لنووچیلر نینگ یاقیلگن/اوچیریلگن/توخته‌تیلگن حالتلری",
        "Target vs Achievement": "دستاوردگه کوره سالیشتیریش هدفی",
        "Top 3 Merchant Wise ETop Up Stock Transfer Ranking": "اینگ یخشی ۳ ته ساتووچیگه اساسلنگن ETop Up سهام انتقال رتبه بندلیگی",
        "Count of Users": "فایده‌لنوچیلر",
        "System Transactional Performance Ratio": "تیزیم المشینوولری نینگ ایشلش عملکری",
        "Reports": "گزارشلر",
        "ETop Up Recharge Report": "قَیته آزیقلنتیریش گزارشی (ریچارد) Etop Up",
        "Bundle Activation Report": "بسته نی فعال ایتیش گزارشی",
        "Unsuccessful Transaction Report": "نا موفق المشیووی گزارشی",
        "MNO's Service Fee Earned Report": "مبایل ترماغی اپراتورلر تامانیدن خذمت کورسه‌تیلگن مصرفلر گزارشی",
        "MNO Wise Sales Trend Report": "مبایل ترماقلری اپراتور اساسیده‌گی ساتیش جریانی گزارشی",
        "Stock Transfer Report": "سهام ساتیب آلیش اوچون بویورتمه گزارشی Etop Up",
        "Wallet Transfer Report": "والت نی ییتکزیش گزارشی (بکسک پول)",
        "MNO Wise ETop Up Available Balance Report": "مبایل ترماغی اپراتوری اساسیده Etop Up موجود بلانس گزارشی",
        "MNO Wise Bundle Balance Activation Report": "مبایل ترماغی اپراتوری اساسیده بسته بیلانس ساتیب آلیش گزارشی",
        "MNO Wise ETop Up Purchase Report": "مبایل اپراتور اساسیده  Etop Up  ساتیب آلیش گزارشی",
        "MNO Wise Bundle Balance Purchase Report": "مبایل ترماغی اپراتور اساسیده بسته بلانس ساتیب آلیش گزارشی",
        "Merchant / Customer eTop Up Wallet Balance Report": "ساتیب آلوچی اساسیده  ETop Up والت بیلانس گزارشی",
        "ZoodPay Profitability Report": "زودپی سودآورلیک گزارشی",
        "Recharge Reversal Report": "قیته تولش گزارشی",
        "ETop Up Stock / Digital Wallet Report of Admin / Super Admin": "مدیر/ارشد مدیر دیجیتال ولات Etop Up موجودی گزارشی",
        "CVM Report": "راپور CVM",
        "On Target Achievement of MNO Report": "مبایل ترماغی اپراتور مقصدیگه ایریشیش گزارشی",
        "Geographical Sales Report": "جغرافیا حدود اساسیده ساتیش گزارشی",
        "Stock Account Statement": "موجود حساب صورت حسابی (سهام)",
        "Money Accounts Statement": "پولی حسابلر صورت حسابی",
        "Upfront Purchased Report": "آلدین ساتیب آلینگنلر گزارشی",
        "Upfront Sales Report": "آلدین ساتیلگنلر گزارشی",
        "Bulk Amount Transfer": "کته مقدارده پول ییتکزیش",
        "Capability to do Bulk Recharge": "کته آزیقه لنتیریش قابلیت",
        "Wallet / Fund Transfer": "بودجه /ولت ییتکزیش",
        "Capability to do Bulk Bundle Activation": "کته بسته نی فعال ایتیش قابلیتی",
        "Career Section Management": "وظیفوی بولیم مدیریتی",
        "Add Data Related to Career": "وظیفه گه تیگیشلی معلوماتنی قوشیش",
        "Remove Data Related to Career": "وظیفه گه تیگیشلی معلوماتنی حذف ایتیش",
        "View all Job Application": "برچه ایشلر درخواستینی کورستیش",
        "Blog Management": "بلاگ مدیرتی",
        "Add Blog": "بلاگ نی قوشیش",
        "Remove Blog": "بلاگ نی حذف ایتیش",
        "View the Blog": "مذکور بلاگ نی کورستیش",
        "Digital wallet": "دیجیتل والت",
        "View Specific Sub Distributor Details": "فرعی توزیع قیلوچی حقیده انیق معلماتنی کورسه‌تیش",
        "Edit Sub Distributor": "فرعی توزیع قیلوچی نی توغریلش",
        "Activate / Deactivate Sub Distributor": "فرعی توزیع قیلوچی نی فعال/غیر فعال ایتیش",
    }
};